<template>
  <div class="ctp00100-top-bg">
    <div class="row justify-center ctp00100-top-container">
      <div class="ctp00100-category q-gutter-y-xs">
        <div class="row items-end">
          <div class="col">
            <label class="text-primary text-weight-bold ctp00100-title">掲載品目数</label>
          </div>
          <div class="col text-right ctp00100-date">
            <span class="q-mr-xs">
              {{ today }}
            </span>
            <label>時点</label>
          </div>
        </div>
        <q-card flat bordered>
          <q-card-section class="q-gutter-y-sm">
            <div
              v-for="item in category"
              :key="item.item_count"
              :class="[
                'row items-end justify-between',
                item.sup_category === 'ALL' && 'ctp00100-sparate',
                'ctp00100-item-name',
              ]"
            >
              <div v-if="item.sup_category !== 'ALL'">
                {{ item.sup_category }}
              </div>
              <div
                v-if="item.sup_category !== 'ALL'"
                class="text-right text-weight-bolder ctp00100-count"
              >
                <router-link
                  v-if="item.item_count !== 0"
                  class="ctp00100-item-font"
                  :to="{
                    name: 'search',
                    params: { type: '1', supCategory: item.sup_category_id },
                  }"
                >
                  {{ commaFormat(item.item_count) }}
                </router-link>
                <span v-if="item.item_count === 0">
                  {{ item.item_count }}
                </span>
              </div>
              <div v-if="item.sup_category === 'ALL'" class="text-primary">
                {{ item.sup_category }}
              </div>
              <div
                v-if="item.sup_category === 'ALL'"
                class="text-right text-weight-bolder ctp00100-count ctp00100-all"
              >
                {{ commaFormat(item.item_count) }}
              </div>
            </div>
          </q-card-section>
        </q-card>
      </div>
      <div class="column ctp00100-right-area">
        <div class="row" style="height: 150px">
          <div class="col flex justify-center">
            <q-btn
              :to="{ name: 'search', params: { type: '0' } }"
              color="primary"
              class="ctp00100-top-button"
            >
              <div class="column items-center">
                <label> キー検索 </label>
                <q-icon size="60px" name="mdi-magnify" />
              </div>
            </q-btn>
            <q-btn
              :to="{ name: 'search', params: { type: '1' } }"
              color="primary"
              class="ctp00100-top-button structure-search"
            >
              <div class="column items-center">
                <label> 構造検索 </label>
                <div style="width: 60px">
                  <img src="../assets/icon_structure.svg" alt="" />
                </div>
              </div>
            </q-btn>
          </div>
        </div>
        <div class="row justify-center" style="height: calc(100% - 150px)">
          <NewsAreaScroll display-screen="1" />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import NewsAreaScroll from '../components/scroll/NewsAreaScroll.vue';
import commaFormat from '../common/utils/numberUtils';
import http from '../common/axios-common';
import ResultStatusCode from '../common/code/ResultStatusCode';
import HttpResponseStatusCode from '../common/code/HttpResponseStatusCode';
import loginUserStore from '../store/loginUserStore';

const router = useRouter();

// カテゴリーinterface
interface Category {
  sup_category_id: number;
  item_count: number;
  sup_category: string;
}

// 掲載品目数
const category = ref<[Category]>();

// システム日付
const today = ref<string>('');

// 掲載品目数取得
const getCategories = () => {
  http
    .post('/ctp001001/category')
    .then((response) => {
      if (response.data.common.status === ResultStatusCode.ERROR) {
        router.push({ name: 'error' });
      } else {
        category.value = response.data.categoryList;
        today.value = response.data.sysDate;
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    });
};

// ログイン情報取得
const getLoginUser = () => {
  const loginUser = loginUserStore();
  const { po_type } = storeToRefs(loginUser);
  http
    .post('/ctp001001/loginUser')
    .then((response) => {
      // 異常終了の場合
      if (response.data.common.status === ResultStatusCode.ERROR) {
        router.push({ name: 'error' });
      } else {
        // ログインユーザー情報をstoreに設定
        loginUser.setLoginUser(response.data.loginUser);
        if (po_type.value === 'PO_RE_ARIBA') {
          router.push({ name: 'orderInquiry' });
        }
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    });
};

// 初期表示処理
getLoginUser();
getCategories();
</script>
<style scoped>
.ctp00100-top-bg {
  position: relative;
  background: var(--q-lightGray);
  min-height: calc(100vh - 50px);
  background-image: url('../assets/top_image.svg');
  background-size: 70%;
  background-position: 10% 60%;
  background-repeat: no-repeat;
}
.ctp00100-top-bg::after {
  content: '';
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: var(--q-white);
  opacity: 0.5;
}
.ctp00100-top-container {
  position: relative;
  width: 80%;
  margin: 0 auto;
  padding: 60px 0 0;
  z-index: 5;
}
.ctp00100-category {
  width: 32%;
  margin: -34px auto 0;
}
.ctp00100-category .ctp00100-title {
  font-size: 1.1rem;
}
.ctp00100-category .ctp00100-date {
  font-size: 0.8rem;
}
.ctp00100-category .ctp00100-count a,
.ctp00100-category .ctp00100-count span,
.ctp00100-category .ctp00100-count.ctp00100-all {
  font-size: 1.2rem;
  color: var(--q-delete);
}
.ctp00100-all {
  font-family: arial black;
}

.ctp00100-category .ctp00100-sparate {
  border-top: 1px solid var(--q-delete);
  padding-top: 10px;
  margin-top: 20px;
}
.ctp00100-right-area {
  width: 66%;
}
.ctp00100-right-area .ctp00100-top-button {
  width: 147px;
  height: 147px;
  font-weight: bold;
  font-size: 1.2rem;
  border-radius: 8px;
  border: 2px solid hsla(0, 0%, 100%, 0.4);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
}

.ctp00100-top-button.structure-search {
  margin-left: 20px;
  border-radius: 8px;
  border: 2px solid hsla(0, 0%, 100%, 0.4);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
}

.ctp00100-item-font {
  font-family: arial black;
  text-decoration: underline black;
  text-underline-offset: 4px;
}

.ctp00100-item-name {
  font-size: 1rem;
}
</style>
